export enum LinkAccountErrors {
  INVALID_EMAIL = 'Invalid email',
  EMPTY = 'Empty',
  NO_ACCOUNT_FOUND = 'No account found for this email. Please verify or contact support.',
}
